import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const settings = {
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },

  getClientId () {
    return store.getters['Client/clientId']
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getSettings () {
    return Axios.get(`api/v1/clients/${this.getClientId()}/configurations/${utils.getLastPathUrl()}`)
  },
  getTabSettings () {
    return Axios.get(`api/v1/clients/${this.getClientId()}/configurations/features`)
  },
  getColorSettings () {
    return Axios.get(`api/v1/clients/${this.getClientId()}/configurations/interfaces`)
  },
  getSiteSettings (siteId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/sites/${siteId}/configurations/${utils.getLastPathUrl()}`)
  },
  saveSettings (settings) {
    return Axios.put(`api/v1/clients/${this.getClientId()}/configurations/${utils.getLastPathUrl()}`, settings)
  },
  saveColorSettings (settings) {
    return Axios.put(`api/v1/clients/${this.getClientId()}/configurations/interfaces`, settings)
  },
  saveSiteSettings(settings){
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/sites/${settings.siteId}/configurations/${utils.getLastPathUrl()}`, settings)
  },
  getLogo () {
    return Axios.get(`api/v1/clients/${this.getClientId()}/configurations/interfaces/image`, { responseType: 'arraybuffer' })
  },
  saveLogo (file) {
    let form = new FormData()
    form.append('imageFile', file)
    return Axios.put(`api/v1/clients/${this.getClientId()}/configurations/${utils.getLastPathUrl()}/image`, form)
  },
  checkMeetProviderConnection (keys) {
    return Axios.post(`${this.getFreeroomUrl()}/api/internal/clients/${this.getClientId()}/meeting-provider/connection-test`, keys)
  },
}
export default settings
